module.exports = __webpack_public_path__ + "img/brain-mapb.725c580e.jpg";